var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import gql from "graphql-tag";
import authentication from "@irati/auth";
import graph from "@irati/utils/services/graph";
var query = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query DownloadTenantTransfers($tenantId: String!) {\n    downloadTenantTransfers(tenantId: $tenantId)\n  }\n"], ["\n  query DownloadTenantTransfers($tenantId: String!) {\n    downloadTenantTransfers(tenantId: $tenantId)\n  }\n"])));
var downloadTenantTransactionsQuery = function () {
    var variables = {
        tenantId: authentication.userTenant().uuid
    };
    var toString = query.loc.source.body;
    return graph({ query: toString, variables: variables })
        .then(function (res) { return res.downloadTenantTransfers; });
};
export default downloadTenantTransactionsQuery;
var templateObject_1;
